/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
// import * as dayjs from 'dayjs';
import dayjs from 'dayjs';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};
const APP_LOCALE = publicRuntimeConfig.APP_LOCALE || 'es';

const DateFormat = (props) => {
  // eslint-disable-next-line
  require(`dayjs/locale/${APP_LOCALE}`);
  return (
    <>
      <style jsx>
        {`
          .text-lowercase {
            text-transform: lowercase;
            display: inline-block;
          }
        `}
      </style>
      <div className="text-lowercase">
        {dayjs(props.children).locale(APP_LOCALE).format(props.format)}
      </div>
    </>
  );
};

DateFormat.defaultProps = {
  format: 'DD MMMM, YYYY',
  children: Date.now()
};

DateFormat.propTypes = {
  format: PropTypes.string,
  children: PropTypes.any
};

export default DateFormat;
